const IMAGE_FALLBACK_WIDTH = 300;
const useFallbackWidthStyle = ({
  containerData,
  isMobile
}) => {
  const shouldUseFallbackWidth = (containerData?.alignment === "LEFT" || containerData?.alignment === "RIGHT") && !containerData.width?.custom && containerData.width?.size !== "SMALL" && containerData.width?.size !== "ORIGINAL" && !isMobile;
  return shouldUseFallbackWidth ? { width: IMAGE_FALLBACK_WIDTH + "px" } : {};
};
export {
  useFallbackWidthStyle
};
//# sourceMappingURL=use-fallback-width-style.js.map
